module.exports = __webpack_public_path__ + "img/kindanRH@2x.24c254ac.png";